import * as Sentry from '@sentry/browser';

import React from 'react';
import ReactDOM from 'react-dom';

import './style/theme.css';
import './style/main.css';
import './style/animations.css';
import './style/components/cross-selling.css';
import './style/responsive/320-minus.css';
import './style/responsive/450-minus.css';
import './style/responsive/990-minus.css';

import 'semantic-ui-css/semantic.min.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
import './i18n/i18n';
import "core-js/stable";
import "whatwg-fetch";
import "./utils/polyfill.js";
import { GoogleAnalyticsContextProvider } from './components/google_analytics/analytics';

import 'moment/min/locales.min';

// Devs should not add sentry to localconfig to prevent useless errors
if(window.weezConfig.sentry) {
	let { dsn, environment } = window.weezConfig.sentry;
    Sentry.init({
        dsn,
        environment,
        release: import.meta.env.VITE_RELEASE || 'NO_RELEASE',
        allowUrls: [
            window.location.host
        ],
        denyUrls: [
            /connect\.facebook\.net\/en_US\/all\.js/i,
        ]
    });
}

ReactDOM.render((
    <GoogleAnalyticsContextProvider>
        <App/>
    </GoogleAnalyticsContextProvider>
), document.getElementById('root'));
